import {
  Dataflow04Icon,
  Home02Icon,
  GitBranch01Icon,
  Briefcase01Icon,
  UserCircleIcon,
  Building01Icon,
  User02Icon,
  ContainerIcon,
  Users01Icon,
  Monitor01Icon,
  Building08Icon,
  Globe01Icon,
  FileAttachment02Icon,
  Target02Icon,
} from "components";
import { Paths, Permissions } from "configs";
import { TFunction } from "i18next";

const getSidebarMenus = ({ t }: { t: TFunction }) => {
  return [
    {
      id: "organization-chart",
      title: t("organizationChart"),
      path: Paths.OrganizationalChart,
      icon: Dataflow04Icon,
      permission: Permissions.OrgChart.View,
    },
    {
      id: "tenant",
      title: t("tenant"),
      path: Paths.Tenants,
      icon: Building08Icon,
      permission: Permissions.Tenant.ViewList,
      onlyAdmin: true,
    },
    {
      id: "organization",
      title: t("organization"),
      path: Paths.Organizations,
      icon: Globe01Icon,
      permission: Permissions.Organization.ViewList,
      onlyAdmin: true,
    },
    {
      id: "company",
      title: t("company"),
      icon: Building01Icon,
      permissionList: [
        Permissions.Department.ViewList,
        Permissions.Branch.ViewList,
        Permissions.Title.ViewList,
      ],
      children: [
        {
          id: "department",
          title: t("department"),
          path: Paths.Departments,
          icon: Home02Icon,
          permission: Permissions.Department.ViewList,
        },
        {
          id: "branch",
          title: t("branch"),
          path: Paths.Branches,
          icon: GitBranch01Icon,
          permission: Permissions.Branch.ViewList,
        },
        {
          id: "title",
          title: t("title"),
          path: Paths.Titles,
          icon: Briefcase01Icon,
          permission: Permissions.Title.ViewList,
        },
        {
          id: "workLevel",
          title: t("workLevel"),
          path: Paths.WorkLevels,
          icon: Target02Icon,
          permission: Permissions.WorkLevel.ViewList,
        },
        {
          id: "contractType",
          title: t("contractType"),
          path: Paths.ContractTypes,
          icon: FileAttachment02Icon,
          permission: Permissions.ContractType.ViewList,
        },
      ],
    },
    {
      id: "employee",
      title: t("employee"),
      path: Paths.Employees,
      icon: User02Icon,
      permission: Permissions.Employee.ViewList,
    },
    {
      id: "groupEmployee",
      title: t("groupEmployee"),
      path: Paths.GroupEmployee,
      icon: Users01Icon,
      permission: Permissions.GroupEmployee.ViewList,
    },
    {
      id: "application",
      title: t("application"),
      path: Paths.Applications,
      icon: ContainerIcon,
      permission: Permissions.Application.ViewList,
      onlyAdmin: true,
    },
    {
      id: "partner",
      title: t("partner", "Partner"),
      path: Paths.Partners,
      icon: Dataflow04Icon,
      permission: Permissions.Partner.ViewList,
      onlyAdmin: true,
    },
    {
      id: "feature",
      title: t("feature"),
      path: Paths.Features,
      icon: Monitor01Icon,
      permission: Permissions.Feature.ViewList,
      onlyAdmin: true,
    },
    {
      id: "role",
      title: t("roleAndPermission"),
      path: Paths.Roles,
      icon: UserCircleIcon,
      permission: Permissions.Role.ViewList,
    },
  ];
};

export default getSidebarMenus;
